"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const video_client_core_1 = require("@video/video-client-core");
const mobx_react_lite_1 = require("mobx-react-lite");
const react_1 = tslib_1.__importStar(require("react"));
const context_1 = require("../../../../context");
const styling_1 = require("../../../../styling");
const utils_1 = require("../../../../styling/utils");
const Select_1 = tslib_1.__importDefault(require("../../../../ui-lib/Inputs/Select"));
const ErrorBoundary_1 = require("../../../ErrorBoundary");
/**
 * @todo: Possibly refactor Select Components
 *
 */
const ModularAudioDeviceSelect = (0, mobx_react_lite_1.observer)(({ classes = {}, ...props }) => {
    var _a;
    const { label } = props;
    /**
     * Component Name (for error msg)
     */
    const componentName = "<AudioDeviceSelect/>";
    /**
     * Access EncoderUiContext & destructure API state
     */
    const ctx = (0, react_1.useContext)(context_1.EncoderUiContext);
    /**
     * Throw error (and trigger ErrorBoundary) if store is undefined.
     * */
    (0, ErrorBoundary_1.useUndefinedStoreError)((ctx === null || ctx === void 0 ? void 0 : ctx.mediaStreamController) != null, componentName);
    /**
     * On input change handler to (1) update API and (2) update component
     * <select> value with user selected audio device.
     */
    const selectMicrophone = (ev) => {
        ctx.mediaStreamController.audioDeviceId = ev.target.value;
    };
    const mergedClasses = (0, styling_1.useStyles)({ source: classes, target: {} }, "select");
    const mergedStyles = (0, utils_1.mergeStylesObjects)(classes, {});
    /**
     * Wrap onChange function in global Error handler (to trigger ErrorBoundary).
     * */
    const handleInputChange = (0, ErrorBoundary_1.useUIEventError)(selectMicrophone, componentName);
    return (react_1.default.createElement(Select_1.default, { classes: mergedStyles, onChange: handleInputChange, value: (_a = ctx.mediaStreamController.audioDeviceId) !== null && _a !== void 0 ? _a : "", label: label !== null && label !== void 0 ? label : "Mic", ...props },
        react_1.default.createElement("option", { disabled: true, value: "", className: mergedClasses.options }, "Select a microphone"),
        video_client_core_1.mediaController.audioDevices().map((item, key) => {
            var _a;
            return (react_1.default.createElement("option", { key: item.deviceId, value: item.deviceId, className: mergedClasses === null || mergedClasses === void 0 ? void 0 : mergedClasses.options }, (_a = item.label) !== null && _a !== void 0 ? _a : `Microphone ${key + 1}`));
        })));
});
const AudioDeviceSelectWithErrorBoundary = ({ classes = {}, ...props }) => {
    const mergedClasses = (0, styling_1.useStyles)({ source: classes, target: {} }, "select");
    const mergedStyles = (0, utils_1.mergeStylesObjects)(classes, {});
    return (react_1.default.createElement(ErrorBoundary_1.ErrorBoundary, { render: () => {
            var _a;
            return (react_1.default.createElement(Select_1.default, { ...props, value: "", classes: mergedStyles, disabled: true, label: "Audio Device: Unavailable" },
                react_1.default.createElement("option", { value: "", className: mergedClasses === null || mergedClasses === void 0 ? void 0 : mergedClasses.options }, (_a = props.fallbackText) !== null && _a !== void 0 ? _a : "Audio Devices Unavailable")));
        } },
        react_1.default.createElement(ModularAudioDeviceSelect, { classes: classes, ...props })));
};
exports.default = AudioDeviceSelectWithErrorBoundary;
//# sourceMappingURL=AudioDeviceSelect.js.map